import request from '../../../helpers/request';

const editFacilityTariff = async (tariff, facility) => {
  await request.put(
    `/RentPlace/rental_house/${facility.id}/tariff`,
    {
      id: tariff.id,
      value: tariff.value,
      tariff: tariff.type,
      rentalHouse: {id: facility.id}
    },
    'При редактировании тарифа произошла ошибка'
  );
};

export default editFacilityTariff;
